<template>
  <label class="vs-select--label input-select-label-primary--active"><slot></slot></label>
</template>

<script>
export default {
  name: "form-label"
};
</script>